import { useEffect, useState } from 'react';
import { Input } from '../../../components/ui/input';
import { adminList, adminUpsertSingleton } from '../../../lib/adminApi';
import { SectionHeader, SaveBar, useSaver, Field, Card } from './_ui';

const EMPTY = {
  email: '', phone: '', phoneDisplay: '',
  whatsappNumber: '', whatsappUrl: '',
  logoUrl: '', logoIcon: '',
  tagline: '', name: 'Science Sorted',
};

export default function ContactSection() {
  const [state, setState] = useState(EMPTY);
  const [settings, setSettings] = useState({ ctaPrimaryUrl: '', socials: {} });
  const [loaded, setLoaded] = useState(false);
  const brandSaver = useSaver();
  const settingsSaver = useSaver();

  useEffect(() => {
    (async () => {
      const [brand, s] = await Promise.all([
        adminList('brand'),
        adminList('site-settings'),
      ]);
      setState({ ...EMPTY, ...(brand || {}) });
      setSettings({
        ctaPrimaryUrl: s?.ctaPrimaryUrl || '',
        socials: s?.socials || {},
      });
      setLoaded(true);
    })();
  }, []);

  if (!loaded) return <p className="text-brand-ink/60">Loading...</p>;

  const saveBrand = () => brandSaver.run(() => adminUpsertSingleton('brand', state));

  const saveSettings = () => settingsSaver.run(async () => {
    const current = await adminList('site-settings');
    await adminUpsertSingleton('site-settings', {
      ...current,
      ctaPrimaryUrl: settings.ctaPrimaryUrl,
      socials: settings.socials,
    });
  });

  return (
    <div className="max-w-3xl">
      <SectionHeader
        title="Contact & Links"
        description="Email, phone, WhatsApp, Tutorbird link and social profiles."
      />

      <Card className="mb-6">
        <div className="grid md:grid-cols-2 gap-4">
          <Field label="Email address" cols={2}>
            <Input value={state.email || ''} onChange={(e) => setState({ ...state, email: e.target.value })} />
          </Field>
          <Field label="Phone (E.164)">
            <Input value={state.phone || ''} onChange={(e) => setState({ ...state, phone: e.target.value })} />
          </Field>
          <Field label="Phone (display)">
            <Input value={state.phoneDisplay || ''} onChange={(e) => setState({ ...state, phoneDisplay: e.target.value })} />
          </Field>
          <Field label="WhatsApp number (digits only)">
            <Input value={state.whatsappNumber || ''} onChange={(e) => setState({ ...state, whatsappNumber: e.target.value })} />
          </Field>
          <Field label="WhatsApp URL">
            <Input value={state.whatsappUrl || ''} onChange={(e) => setState({ ...state, whatsappUrl: e.target.value })} />
          </Field>
          <Field label="Tagline" cols={2}>
            <Input value={state.tagline || ''} onChange={(e) => setState({ ...state, tagline: e.target.value })} />
          </Field>
        </div>
        <div className="mt-5">
          <SaveBar {...brandSaver} onSave={saveBrand} dataTestId="save-contact" />
        </div>
      </Card>

      <Card>
        <div className="text-sm font-semibold text-brand-ink mb-3">Trial booking & socials</div>
        <div className="grid md:grid-cols-2 gap-4">
          <Field label="Tutorbird free-trial URL" cols={2}>
            <Input
              value={settings.ctaPrimaryUrl}
              onChange={(e) => setSettings({ ...settings, ctaPrimaryUrl: e.target.value })}
            />
          </Field>
          {['instagram', 'facebook', 'youtube', 'tiktok', 'linkedin'].map((k) => (
            <Field key={k} label={k[0].toUpperCase() + k.slice(1)}>
              <Input
                value={settings.socials?.[k] || ''}
                onChange={(e) =>
                  setSettings({ ...settings, socials: { ...settings.socials, [k]: e.target.value } })
                }
              />
            </Field>
          ))}
        </div>
        <div className="mt-5">
          <SaveBar {...settingsSaver} onSave={saveSettings} dataTestId="save-socials" />
        </div>
      </Card>
    </div>
  );
}
